import { useAtom } from "@reatom/npm-react";
import { PropsWithChildren, useCallback, useEffect, useMemo } from "react";
import { API } from "src/api";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { clientIdAtom } from "src/store/atoms";
import {
  MenuLayout,
  MenuLayoutMobile,
  ResponsiveProductSamplesWidget,
  WelcomeModal,
} from "src/widgets";
import { ConsentModal } from "src/widgets/ConsentModal";
import { ResponsiveProductDetailWidget } from "src/widgets/ResponsiveProductDetailWidget";

export const ClientLayout = ({ children }: PropsWithChildren) => {
  const { isMobile } = useGravityDevice();

  const Layout = useMemo(
    () => (isMobile ? MenuLayoutMobile : MenuLayout),
    [isMobile],
  );

  const [localClientId, setLocalClientId] = useAtom(clientIdAtom);

  const setClientId = useCallback(
    (clientId: string) => {
      if (clientId === localClientId || !clientId) return;

      setLocalClientId(clientId);
      API.yandexApi.yandexControllerSetYandexClientId({ clientId });
    },
    [localClientId, setLocalClientId],
  );

  useEffect(() => {
    window.ym?.(97273184, "getClientID", setClientId);
  }, [setClientId]);

  return (
    <Layout>
      <WelcomeModal />
      <ConsentModal />
      <ResponsiveProductSamplesWidget />
      <ResponsiveProductDetailWidget />
      {children}
    </Layout>
  );
};
